(() => {
  const ROOT = '[data-qb-root]';

  function formatter(currency) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency',
        currency: currency || 'USD'
      });
    } catch (_) {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
      });
    }
  }

  function parseVariants(root) {
    const el = root.querySelector('[data-qb-variants]');
    if (!el) return [];

    try {
      return JSON.parse(el.textContent || '[]');
    } catch (_) {
      return [];
    }
  }

  function readDiscount(root, qty) {
    return Number(root.getAttribute(`data-discount-${qty}`) || 0);
  }

  function init(root) {
    if (!root || root.dataset.qbReady === 'true') return;
    root.dataset.qbReady = 'true';

    const sectionId = root.dataset.sectionId;

    const scope =
      document.getElementById(`MainProduct-${sectionId}`) ||
      root.closest('.shopify-section') ||
      document;

    const money = formatter(root.dataset.currency || 'USD');
    const variants = parseVariants(root);

    const tiers = [
      { qty: 10, discount: readDiscount(root, 10) },
      { qty: 7, discount: readDiscount(root, 7) },
      { qty: 5, discount: readDiscount(root, 5) },
      { qty: 3, discount: readDiscount(root, 3) },
      { qty: 2, discount: readDiscount(root, 2) }
    ].filter(t => t.discount > 0);

    const cards = [...root.querySelectorAll('[data-qb-tier-card]')];

    const ui = {
      title: root.querySelector('[data-qb-status-title]'),
      percent: root.querySelector('[data-qb-status-percent]'),
      copy: root.querySelector('[data-qb-status-copy]'),
      breakdown: root.querySelector('[data-qb-breakdown]'),
      discountedLabel: root.querySelector('[data-qb-discounted-label]'),
      discountedSubtotal: root.querySelector('[data-qb-discounted-subtotal]'),
      discountLabel: root.querySelector('[data-qb-discount-label]'),
      discountAmount: root.querySelector('[data-qb-discount-amount]'),
      extraRow: root.querySelector('[data-qb-extra-row]'),
      extraLabel: root.querySelector('[data-qb-extra-label]'),
      extraTotal: root.querySelector('[data-qb-extra-total]'),
      regularTotal: root.querySelector('[data-qb-regular-total]'),
      youSave: root.querySelector('[data-qb-you-save]'),
      final: root.querySelector('[data-qb-final]')
    };

    const quantityInput = () =>
      scope.querySelector('input[name="quantity"]');

    function currentQty() {
      return Math.max(
        1,
        parseInt(quantityInput()?.value || '1', 10) || 1
      );
    }

    function variantId() {
      return String(
        scope.querySelector(
          'form[action*="/cart/add"] [name="id"]'
        )?.value || ''
      );
    }

    function unitCents() {
      const id = variantId();
      const variant = variants.find(
        item => String(item.id) === id
      );

      if (variant) {
        return Number(variant.price || 0);
      }

      return Number(root.dataset.unitPrice || 0);
    }

    const fmt = cents =>
      money.format((Math.max(0, cents) || 0) / 100);

    const tierFor = qty =>
      tiers.find(tier => qty >= tier.qty) || null;

    function calc(qty, unit) {
      const tier = tierFor(qty);
      const regularTotal = qty * unit;

      if (!tier) {
        return {
          tier: null,
          discountedQty: 0,
          regularQty: qty,
          regularTotal,
          discountedSubtotal: 0,
          discountAmount: 0,
          finalTotal: regularTotal
        };
      }

      const discountedQty = tier.qty;
      const regularQty = qty - discountedQty;
      const discountedSubtotal = discountedQty * unit;

      const discountAmount = Math.round(
        discountedSubtotal * tier.discount / 100
      );

      return {
        tier,
        discountedQty,
        regularQty,
        discountedSubtotal,
        regularTotal,
        discountAmount,
        finalTotal: regularTotal - discountAmount
      };
    }

    function updateButton(qty, regularTotal, discountAmount, finalTotal) {
      const button = scope.querySelector('.product-form__submit');
      if (!button || button.disabled) return;

      const label = button.querySelector('span') || button;

      if (!button.dataset.qbOriginalText) {
        button.dataset.qbOriginalText = label.textContent.trim();
      }

      if (discountAmount > 0) {
        label.innerHTML = `
          <span class="qb-cart-button__main">
            Add ${qty} to cart · ${fmt(finalTotal)}
          </span>
          <span class="qb-cart-button__save">
            You save ${fmt(discountAmount)}
            <span class="qb-cart-button__regular">
              · Regular ${fmt(regularTotal)}
            </span>
          </span>
        `;

        button.classList.add('qb-cart-button--saving');
      } else {
        label.innerHTML = `
          <span class="qb-cart-button__main">
            Add ${qty} to cart · ${fmt(finalTotal)}
          </span>
        `;

        button.classList.remove('qb-cart-button--saving');
      }
    }

    function render() {
      const qty = currentQty();
      const unit = unitCents();
      const result = calc(qty, unit);

      cards.forEach(card => {
        card.classList.toggle(
          'is-active',
          !!result.tier &&
          Number(card.dataset.qty) === result.tier.qty
        );
      });

      if (!result.tier) {
        if (ui.title) {
          ui.title.textContent =
            'Choose a quantity to unlock savings';
        }

        if (ui.percent) {
          ui.percent.textContent = '';
        }

        if (ui.copy) {
          ui.copy.textContent =
            'Buy 2 or more boxes to save.';
        }

        if (ui.breakdown) {
          ui.breakdown.hidden = true;
        }

        updateButton(
          qty,
          result.regularTotal,
          0,
          result.finalTotal
        );

        return;
      }

      if (ui.title) {
        ui.title.textContent =
          `${result.tier.discount}% SAVING APPLIED`;
      }

      if (ui.percent) {
        ui.percent.textContent =
          `SAVE ${fmt(result.discountAmount)}`;
      }

      if (ui.copy) {
        ui.copy.textContent =
          result.regularQty > 0
            ? `${result.discountedQty} boxes get ${result.tier.discount}% OFF + ${result.regularQty} ${result.regularQty === 1 ? 'box' : 'boxes'} at regular price.`
            : `${result.discountedQty} boxes get ${result.tier.discount}% OFF.`;
      }

      if (ui.breakdown) {
        ui.breakdown.hidden = false;
      }

      if (ui.discountedLabel) {
        ui.discountedLabel.textContent =
          `${result.discountedQty} boxes × ${fmt(unit)}`;
      }

      if (ui.discountedSubtotal) {
        ui.discountedSubtotal.textContent =
          fmt(result.discountedSubtotal);
      }

      if (ui.discountLabel) {
        ui.discountLabel.textContent =
          `${result.tier.discount}% quantity saving`;
      }

      if (ui.discountAmount) {
        ui.discountAmount.textContent =
          `−${fmt(result.discountAmount)}`;
      }

      if (result.regularQty > 0) {
        if (ui.extraRow) {
          ui.extraRow.hidden = false;
        }

        if (ui.extraLabel) {
          ui.extraLabel.textContent =
            `${result.regularQty} extra ${result.regularQty === 1 ? 'box' : 'boxes'} at regular price`;
        }

        if (ui.extraTotal) {
          ui.extraTotal.textContent =
            fmt(result.regularQty * unit);
        }
      } else if (ui.extraRow) {
        ui.extraRow.hidden = true;
      }

      if (ui.regularTotal) {
        ui.regularTotal.textContent =
          fmt(result.regularTotal);
      }

      if (ui.youSave) {
        ui.youSave.textContent =
          `−${fmt(result.discountAmount)}`;
      }

      if (ui.final) {
        ui.final.textContent =
          fmt(result.finalTotal);
      }

      updateButton(
        qty,
        result.regularTotal,
        result.discountAmount,
        result.finalTotal
      );
    }

    cards.forEach(card => {
      card.addEventListener('click', () => {
        const input = quantityInput();

        if (!input) return;

        input.value = String(
          card.dataset.qty || 1
        );

        input.dispatchEvent(
          new Event('input', { bubbles: true })
        );

        input.dispatchEvent(
          new Event('change', { bubbles: true })
        );

        setTimeout(render, 60);
      });
    });

    scope.addEventListener('input', event => {
      if (
        event.target?.matches?.(
          'input[name="quantity"], [name="id"]'
        )
      ) {
        requestAnimationFrame(render);
      }
    });

    scope.addEventListener('change', () => {
      requestAnimationFrame(render);
    });

    scope.addEventListener('click', event => {
      if (
        event.target.closest('quantity-input') ||
        event.target.closest('[name="plus"]') ||
        event.target.closest('[name="minus"]')
      ) {
        setTimeout(render, 80);
      }
    });

    document.addEventListener(
      'variant:change',
      () => setTimeout(render, 80)
    );

    render();
    setTimeout(render, 150);
  }

  function boot() {
    document.querySelectorAll(ROOT).forEach(init);
  }

  document.addEventListener(
    'DOMContentLoaded',
    boot
  );

  document.addEventListener(
    'shopify:section:load',
    boot
  );

  boot();
})();
